import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../modules';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { Col, Row, Tabs } from 'antd';
import ChannelService from '../util/ChannelService';
import { getLoggedInUserAsync } from '../modules/auth';
import TabPane from 'antd/lib/tabs/TabPane';
import ProjectListContainer from './projects/ProjectListContainer';
import Title from 'antd/lib/typography/Title';
import ToDoListContainer from './projects/ToDoListContainer';

interface MainMatchParams {
  enterpriseId: string;
  projectId: string;
}

function MainContainer({
  match,
  history,
}: RouteComponentProps<MainMatchParams>) {
  const { enterpriseId } = match.params;
  const dispatch = useDispatch();

  const user = useSelector((state: RootState) => state.auth.auth.data);

  useEffect(() => {
    if (user === null) {
      dispatch(getLoggedInUserAsync.request(null));
    } else {
      ChannelService.boot({
        pluginKey: process.env.REACT_APP_CHANNEL_ID_PLUGIN_KEY,
        profile: {
          email: user.email,
          name: user.name,
        },
      });
    }
  }, [user, dispatch]);

  return (
    <>
      <Row>
        <Col flex={1}>
          <Title level={3}>공사관리</Title>
        </Col>
      </Row>
      <Tabs destroyInactiveTabPane>
        <TabPane tab="프로젝트" key="1">
          <ProjectListContainer enterpriseId={enterpriseId} />
        </TabPane>
        <TabPane tab="내 할일" key="2">
          <ToDoListContainer enterpriseId={enterpriseId} />
        </TabPane>
      </Tabs>
    </>
  );
}

export default withRouter(MainContainer);
